import { useState, useContext } from "react";
import { LoginModal } from "../components/LoginModal";
import axiosInstance from "../utils/axiosInstance";
import { Alert } from "flowbite-react";
import { HiInformationCircle } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../utils/UserContext";
import { Spinner } from "flowbite-react";
import TextInput from "../components/TextInput";
import { useError } from "../contexts/ErrorContext";
import Logo from "../components/Logo";
import LoadingOverlay from "../components/LoadingOverlay";
import { decodeJwtPayload } from "../utils/jwtUtils";
import { Button } from "@mui/material";

export function Login() {
  const { setErrors } = useError();
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [email, setEmail] = useState();
  const { user, updateUser } = useContext(UserContext);
  const [enableSpinner, setEnableSpinner] = useState(false);
  const [enableOverlay, setEnableOverlay] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setEnableSpinner(true);
    axiosInstance
      .post(`/v51/sessions`, {
        email: email,
      })
      .then((res) => {
        setEnableSpinner(false);
        console.log(res);
        if (res.status === 201) {
          setOpenModal(true);
        }
      })
      .catch((e) => {
        setEnableSpinner(false);
        console.log(e);
        setErrors([
          e.response?.data?.message ||
            "An internal error occurred, please try again later.",
        ]);
      });
  };

  const handlePinSubmit = (emailPin, TOTP, setError) => {
    if (emailPin.length !== 4 || /\D/.test(emailPin)) {
      return "Invalid pin format";
    }
    if (TOTP.length !== 6 || /\D/.test(TOTP)) {
      return "Invalid atuthentificator app code format";
    }
    axiosInstance
      .post(`/v51/sessions`, {
        email: email,
        pin: emailPin,
        appPin: TOTP,
      })
      .then((res) => {
        if (res.status === 201) {
          setOpenModal(false);
          sessionStorage.setItem("token", res.headers["location"]);
          updateUser(decodeJwtPayload(res.headers["location"]));
          navigate("/home");
        }
      })
      .catch((e) => {
        console.log(e);
        setError(e.response.data.message);
      });
  };

  return (
    <>
      <section className="">
        <div className="mx-auto flex min-h-screen flex-col items-center justify-center px-6 py-8 lg:py-0">
          <a
            href="#"
            className="mb-6 flex items-center text-2xl font-semibold text-gray-900 dark:text-white"
          >
            <Logo className="mr-2 h-36" />
          </a>
          <div className="w-full rounded-lg bg-white shadow dark:border dark:border-gray-700 dark:bg-gray-800 sm:max-w-md md:mt-0 xl:p-0">
            <div className="space-y-4 p-6 sm:p-8 md:space-y-6">
              <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 dark:text-white md:text-2xl">
                Sign in to your account
              </h1>
              <form
                className="space-y-4 md:space-y-6"
                onSubmit={handleSubmit}
                action="#"
              >
                <TextInput
                  label="Your email"
                  type="email"
                  value={email}
                  setValue={(event) => setEmail(event.target.value)}
                  name="email"
                  placeholder="name@company.com"
                />
                <button
                  class="mb-2 me-2 rounded-lg bg-gray-800 px-5 py-2.5 text-sm font-medium text-white hover:bg-gray-900
                 focus:outline-none focus:ring-4 focus:ring-gray-300
                 dark:border-gray-700
                 dark:bg-gray-50 dark:text-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700"
                >
                  {enableSpinner ? (
                    <Spinner aria-label="Default status example" />
                  ) : (
                    "Sign in"
                  )}
                </button>
                <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                  Don’t have an account yet?{" "}
                  <Button onClick={() => navigate("/register")}>Sign up</Button>
                </p>
              </form>
            </div>
          </div>
        </div>
      </section>
      <LoginModal
        email={email}
        show={openModal}
        onClose={() => setOpenModal(false)}
        handleSubmit={handlePinSubmit}
      />
      <LoadingOverlay enabled={enableOverlay} />
    </>
  );
}
